import { Component, Input } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-check-all-generic',
    template: `
    <mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()"
                  [checked]="isChecked()"
                  (click)="$event.stopPropagation()"
                  (change)="toggleSelection($event)">
      {{text}}
    </mat-checkbox>
  `,
    styles: [],
    standalone: false
})
export class SelectCheckAll {
  @Input() model: any;
  @Input() values = [];
  @Input() tipo: any;
  @Input() text = 'Todas';

  constructor() { }

  isChecked(): boolean {
    return this.model.value && this.values.length
      && this.model.value.length === this.values.length;
  }

  isIndeterminate(): boolean {
    return this.model.value && this.values.length && this.model.value.length
      && this.model.value.length < this.values.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    const data = [];
    this.tipo === 1 ? this.values.forEach(value => data.push(value.idCiudad)) : this.values.forEach(value => data.push(value.idEstado));
    if (change.checked) {
      this.model.setValue(data);
    } else {
      this.model.setValue([]);
    }
  }
}
